import { onlineQuestionnaireSectionValidationMap } from 'dzb/inquiry/steps/retailerData/sections/onlineQuestionnaireSection/validations';
import { retailerInformationSectionValidationMap } from 'dzb/inquiry/steps/retailerData/sections/retailerInformationSection/validations';

export const dzbRetailerDataFieldValidation = {
  ...onlineQuestionnaireSectionValidationMap,
  ...retailerInformationSectionValidationMap,
};
